export const LOG_OUT = 'LOG_OUT';
export const RESET_STORE = 'RESET';
